import React from 'react'
import './GetTheApp.css'
import { Icon } from '../../components/gp'

const iosUrl = 'https://apps.apple.com/us/app/gopowerev/id1497166165'
const androidUrl =
    'https://play.google.com/store/apps/details?id=com.gopowerev.consumer'

const storeBtn = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 12,
    height: 56,
    padding: '0 22px',
    background: 'var(--gp-ink)',
    color: '#FFFFFF',
    borderRadius: 'var(--gp-r-md)',
    border: 'none',
    cursor: 'pointer',
    textDecoration: 'none',
    transition: 'background 0.15s ease, transform 0.1s ease',
}

const AppleGlyph = () => (
    <svg width="22" height="26" viewBox="0 0 22 26" fill="currentColor">
        <path d="M17.5 13.5c0-3.2 2.6-4.7 2.7-4.8-1.5-2.2-3.8-2.5-4.6-2.5-2-.2-3.8 1.2-4.8 1.2s-2.5-1.2-4.1-1.1c-2.1 0-4 1.2-5.1 3.1-2.2 3.8-.6 9.4 1.5 12.5 1.1 1.5 2.3 3.2 3.9 3.2 1.6-.1 2.2-1 4.1-1 2 0 2.5 1 4.2 1 1.7 0 2.8-1.5 3.9-3 1.2-1.7 1.7-3.4 1.7-3.5-.1 0-3.4-1.3-3.4-5.1zM14.4 4c.9-1.1 1.5-2.5 1.3-4-1.3.1-2.8.9-3.7 1.9-.8.9-1.6 2.4-1.4 3.8 1.4.1 2.9-.7 3.8-1.7z" />
    </svg>
)

const PlayGlyph = () => (
    <svg width="22" height="26" viewBox="0 0 22 26" fill="none">
        <path d="M1.6 1.5L13 13 1.6 24.5c-.4-.3-.6-.8-.6-1.4V2.9c0-.6.2-1.1.6-1.4z" fill="#34A853" />
        <path d="M16.1 9.9L13 13l3.1 3.1 3.7-2.1c1-.6 1-2 0-2.6l-3.7-2.5z" fill="#FBBC04" />
        <path d="M2.7 1.1c-.4-.1-.8-.1-1.1.1L13 13l3.1-3.1L2.7 1.1z" fill="#EA4335" />
        <path d="M13 13L1.6 24.5c.3.2.7.2 1.1.1L16.1 16.1 13 13z" fill="#4285F4" />
    </svg>
)

const GetTheApp = (props) => {
    const open = (url) => window.open(url, '_blank')

    return (
        <div style={{ maxWidth: 720, margin: '0 auto' }}>
            {/* Green hero card */}
            <div
                style={{
                    position: 'relative',
                    background: 'var(--gp-brand)',
                    color: '#FFFFFF',
                    borderRadius: 'var(--gp-r-lg)',
                    padding: '24px 28px',
                    overflow: 'hidden',
                    marginBottom: 28,
                }}
            >
                <div
                    style={{
                        position: 'absolute',
                        right: -120,
                        top: -120,
                        width: 380,
                        height: 380,
                        borderRadius: '50%',
                        border: '1px solid rgba(182,242,115,0.18)',
                        pointerEvents: 'none',
                    }}
                />
                <div
                    style={{
                        position: 'absolute',
                        right: -60,
                        top: -60,
                        width: 240,
                        height: 240,
                        borderRadius: '50%',
                        border: '1px solid rgba(182,242,115,0.12)',
                        pointerEvents: 'none',
                    }}
                />

                <span
                    style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 6,
                        padding: '4px 10px',
                        borderRadius: 999,
                        background: 'var(--gp-lime-soft)',
                        color: 'var(--gp-brand)',
                        font: 'var(--gp-micro)',
                        letterSpacing: 0.4,
                        position: 'relative',
                    }}
                >
                    <span
                        style={{
                            width: 6,
                            height: 6,
                            borderRadius: '50%',
                            background: 'var(--gp-brand)',
                        }}
                    />
                    Request submitted
                </span>
                <h2
                    style={{
                        margin: '12px 0 6px',
                        font: '500 22px/1.2 var(--gp-font)',
                        color: '#FFFFFF',
                        position: 'relative',
                    }}
                >
                    Pending property manager approval
                </h2>
                <p
                    style={{
                        margin: 0,
                        font: 'var(--gp-body)',
                        color: 'rgba(255,255,255,0.85)',
                        maxWidth: 520,
                        position: 'relative',
                    }}
                >
                    We've sent your request. You'll receive an email as soon as you're
                    approved — usually within 24 hours.
                </p>
            </div>

            {/* Store buttons */}
            <div
                style={{
                    display: 'flex',
                    gap: 14,
                    justifyContent: 'center',
                    flexWrap: 'wrap',
                    marginBottom: 22,
                }}
            >
                <button
                    type="button"
                    onClick={() => open(iosUrl)}
                    aria-label="Download on the App Store"
                    style={storeBtn}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.background = '#000000'
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.background = 'var(--gp-ink)'
                    }}
                >
                    <AppleGlyph />
                    <span
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                            lineHeight: 1.1,
                        }}
                    >
                        <span
                            style={{
                                font: '500 10px/1 var(--gp-font)',
                                letterSpacing: 0.6,
                                textTransform: 'uppercase',
                                opacity: 0.75,
                            }}
                        >
                            Download on the
                        </span>
                        <span style={{ font: '500 18px/1.1 var(--gp-font)' }}>
                            App Store
                        </span>
                    </span>
                </button>
                <button
                    type="button"
                    onClick={() => open(androidUrl)}
                    aria-label="Get it on Google Play"
                    style={storeBtn}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.background = '#000000'
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.background = 'var(--gp-ink)'
                    }}
                >
                    <PlayGlyph />
                    <span
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                            lineHeight: 1.1,
                        }}
                    >
                        <span
                            style={{
                                font: '500 10px/1 var(--gp-font)',
                                letterSpacing: 0.6,
                                textTransform: 'uppercase',
                                opacity: 0.75,
                            }}
                        >
                            Get it on
                        </span>
                        <span style={{ font: '500 18px/1.1 var(--gp-font)' }}>
                            Google Play
                        </span>
                    </span>
                </button>
            </div>

            <div style={{ textAlign: 'center' }}>
                <span
                    onClick={() => props.setupComplete()}
                    style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: 4,
                        font: 'var(--gp-body-med)',
                        color: 'var(--gp-brand)',
                        cursor: 'pointer',
                    }}
                >
                    View your account dashboard
                    <Icon name="chevron" size={14} />
                </span>
            </div>
        </div>
    )
}

export default GetTheApp
